// @ts-check
// Papéis do formulário de convite (Configurações > Membros, contrato de equipe, seção 3.2): só os que o servidor
// aceita para quem convida (`invitableRoleIds` de GET /rest/team/roles), para a tela não oferecer opção que sempre
// falha. Sem a lista (API antiga, modo demonstração), todos os papéis atribuíveis, como antes.

/**
 * @typedef {{ id: string, canBeAssignedToUsers: boolean }} InvitableRole
 */

/**
 * @template {InvitableRole} TRole
 * @param {TRole[]} roles @param {string} defaultRoleId @param {string[] | undefined} invitableRoleIds
 * @returns {{ roles: TRole[], includeDefault: boolean, initialRoleId: string, canInvite: boolean }}
 *   includeDefault: a opção "Papel padrão" (valor vazio); initialRoleId: o valor escolhido ao abrir; canInvite: há alguma
 *   opção (sem nenhuma, a tela explica em vez de mostrar o formulário)
 */
export function inviteRoleOptions(roles, defaultRoleId, invitableRoleIds) {
  const assignable = roles.filter((role) => role.canBeAssignedToUsers);
  if (!invitableRoleIds) return { roles: assignable, includeDefault: true, initialRoleId: '', canInvite: true };
  const invitable = new Set(invitableRoleIds);
  const options = assignable.filter((role) => invitable.has(role.id));
  const includeDefault = invitable.has(defaultRoleId);
  return { roles: options, includeDefault, initialRoleId: includeDefault ? '' : options[0]?.id ?? '', canInvite: options.length > 0 };
}
